module.exports = __webpack_public_path__ + "static/fog-3408054e5f083993c59b1b92204fbc12.png";